import React, { useEffect, useState } from "react";
import { Trash, Plus, X, Star } from "@phosphor-icons/react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const EMPTY = { name: "", location: "", rating: 5, body: "" };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/testimonials").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name || !form.body) return toast.error("Name and review body required");
    await api.post("/testimonials", form);
    toast.success("Added");
    setOpen(false);
    setForm(EMPTY);
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Delete this testimonial?")) return;
    await api.delete(`/testimonials/${id}`);
    load();
  };

  return (
    <div className="p-8 md:p-10" data-testid="admin-testimonials">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8">
        <div>
          <div className="overline mb-2">Reviews</div>
          <h1 className="font-display text-5xl uppercase text-white leading-none">Testimonials</h1>
          <p className="text-white/60 mt-2 text-sm">Customer reviews shown on the homepage.</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary" data-testid="new-testimonial-btn"><Plus size={18} weight="bold" /> Add Review</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((t) => (
          <div key={t.id} className="admin-card relative group" data-testid={`testimonial-row-${t.id}`}>
            <div className="flex gap-0.5 text-atc-red mb-4">
              {Array.from({ length: t.rating || 5 }).map((_, i) => (<Star key={i} size={14} weight="fill" />))}
            </div>
            <p className="text-white/90">"{t.body}"</p>
            <div className="mt-5 pt-4 border-t border-[#2a2a2a] flex items-end justify-between">
              <div>
                <div className="font-heading uppercase text-white">{t.name}</div>
                {t.location && <div className="font-mono text-xs text-white/50 mt-1">{t.location}</div>}
              </div>
              <button onClick={() => del(t.id)} className="border border-[#333] hover:border-atc-red p-2 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`delete-testimonial-${t.id}`}><Trash size={14} weight="bold" /></button>
            </div>
          </div>
        ))}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-atc-black/80 flex items-start justify-center p-4 overflow-y-auto">
          <div className="bg-[#1f1f1f] border-2 border-atc-red max-w-lg w-full p-8 my-10">
            <div className="flex items-center justify-between mb-6">
              <h2 className="font-display text-3xl uppercase text-white">Add review</h2>
              <button onClick={() => setOpen(false)} className="text-white/60 hover:text-atc-red"><X size={24} weight="bold" /></button>
            </div>
            <div className="space-y-5">
              <div><div className="admin-label">Customer name *</div><input className="admin-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="t-name" /></div>
              <div><div className="admin-label">Location</div><input className="admin-input" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} placeholder="e.g., Shrewsbury, PA" data-testid="t-location" /></div>
              <div>
                <div className="admin-label">Rating</div>
                <div className="flex gap-1">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <button key={n} onClick={() => setForm({ ...form, rating: n })} className={n <= form.rating ? "text-atc-red" : "text-white/20"} data-testid={`t-rating-${n}`}>
                      <Star size={28} weight="fill" />
                    </button>
                  ))}
                </div>
              </div>
              <div><div className="admin-label">Review *</div><textarea rows={4} className="admin-input" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="t-body" /></div>
              <div className="flex gap-3 pt-4 border-t border-[#2a2a2a]">
                <button onClick={save} className="btn-primary" data-testid="save-testimonial-btn">Save</button>
                <button onClick={() => setOpen(false)} className="btn-ghost-white">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
